import React from 'react';
import { Box, Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { sizes } from 'src/styles/Media.styled';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import { StyledShippingDetails } from '../replenListViewDesktop/RowTemplateDesktop';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import SelectedShipToAddressLabel from 'src/common/components/selectedShipToAddressLabel/SelectedShipToAddressLabel';
import { MainContainerItems } from 'src/common/components/createTemplate/CreateTemplate.styled';
import { Title } from 'src/common/components/Procedure.styled';
import { Subtitle } from 'src/common/components/orderDetails/trackingNumberLabel/TrackingNumberLabel.styled';
import { getDisplayDate } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { VISIBLE } from 'src/constants/appConstants';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
}));

const RowTemplateMobile = ({
    item,
    idx,
    checkboxClickHandler,
    quantityInputChangeHandler,
}) => {
    const classes = useStyles();
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const { t } = useTranslation();

    const { transferRecipientVisibility } = useSelector(
        (state) => state.loginReducer
    );
    const TransferRecipientSelectedValue = useSelector(
        (state) =>
            state.reportUsageShippingDetailsReducer.gridData[0]?.shippingDetails
                ?.transferRecipient
    );
    const isTransferRecipient = () => {
        if (
            transferRecipientVisibility == VISIBLE &&
            (TransferRecipientSelectedValue !== null) &
                (TransferRecipientSelectedValue !== undefined) &&
            //  typeof isTransferRecipientSelected === 'object' &&
            Object.entries(TransferRecipientSelectedValue).length !== 0
        ) {
            return true;
        } else return false;
    };

    const getSelectedShipToAddress = (item) => (
        <span>
            <span className="report-usage-account-dt-mask">{item?.accountName ? item.accountName : ''}</span>
            <br />
            <span className="report-usage-shipping-address-dt-mask">{item?.addressLine1}</span>
            <br />
            <span className="report-usage-shipping-address-dt-mask">{item?.city}</span>{', '}<span className="report-usage-shipping-address-dt-mask">{item?.region ? item.region : ''}</span>
            <br />
            <span className="report-usage-shipping-address-dt-mask">{item?.postalCode}</span>
        </span>
    );

    return (
        <>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <Grid container alignItems={'flex-start'}>
                    <Grid
                        item
                        md={4}
                        style={{ display: 'flex', width: '100%' }}
                    >
                        <Checkbox
                            checked={item.isSelected}
                            name={item.cfn}
                            onCheckboxSelectionChange={(e) =>
                                checkboxClickHandler(e, item)
                            }
                            disabled={item.isExcludedItem}
                            checkboxBorder={'1px solid #555555'}
                        />
                        <TextWithClicks
                            classes={classes}
                            media={{
                                titleArea: 6,
                                buttonnsArea: 6,
                                xs: 3,
                                lg: 2,
                            }}
                            leftTitle={item.cfn}
                            typeNonTissue={item.salesOrg === 'S002' && 'NT'}
                            typeEA={item.uom}
                            styleObj={{
                                labelStyle: { padding: '0 0 8px' },
                                tagsStyle: { padding: '3px 0 0' },
                            }}
                            justifyContentVal={'flex-end'}
                            marginLeft={isMobileView ? '10px' : '16px'}
                        />
                    </Grid>
                    <Grid
                        item
                        md={4}
                        style={
                            isMobileView
                                ? {
                                      marginLeft: '28px',
                                      display: 'flex',
                                      width: '100%',
                                  }
                                : {
                                      marginLeft:
                                          item.isInvalidReplenQty ===
                                          t(
                                              'productValidationMessages.mustEnterValidQty'
                                          )
                                              ? !isMobileView
                                                  ? '37px'
                                                  : '200px'
                                              : item.isInvalidReplenQty ===
                                                t(
                                                    'consignmentBilling.replen.replenListView.replenListViewMobile.replenishmentCannotEnterValidQty'
                                                )
                                              ? '80px'
                                              : !isMobileView
                                              ? '37px'
                                              : '200px',
                                      display: 'flex',
                                      width: '100%',
                                  }
                        }
                    >
                        <Grid xs={8} sm={8}>
                            {!isMobileView ? (
                                <CustomLabel
                                    fWeight={'normal'}
                                    fSize={'13px !important'}
                                    paddingRight={'2rem !important'}
                                    color={'#140F4B'}
                                    label={item.description}
                                    fontFamily={'AvenirNextWorld Regular'}
                                />
                            ) : (
                                <CustomLabel
                                    fSize={'13px !important'}
                                    paddingRight={'2rem !important'}
                                    color={'#000000'}
                                    label={item.description}
                                    fontFamily={'AvenirNextWorld Regular'}
                                />
                            )}
                        </Grid>
                        <Grid xs={4} sm={4}>
                            {!item.isExcludedItem && (
                                <TextWithInputs
                                    width={!isMobileView ? 'unset' : '100%'}
                                    placeholder={t(
                                        'consignmentBilling.replen.replenListView.replenListViewMobile.qty'
                                    )}
                                    value={
                                        item.newReplenQty !== undefined
                                            ? item.newReplenQty
                                            : item.replenQty
                                    }
                                    onkeyUp={(e) =>
                                        quantityInputChangeHandler(
                                            e,
                                            idx,
                                            'change'
                                        )
                                    }
                                    onBlurEvent={(e) =>
                                        quantityInputChangeHandler(
                                            e,
                                            idx,
                                            'blur'
                                        )
                                    }
                                    inputBorder={
                                        item.isInvalidReplenQty?.length > 0 &&
                                        '2px solid #FACFD6'
                                    }
                                    maxLength={3}
                                    inputHeight={'40px'}
                                    inputWidth={'48px'}
                                    alignText={'center'}
                                    showError={false}
                                    // errorMsg={item.isInvalidReplenQty}
                                    inputMarginLeft={
                                        isMobileView
                                            ? '44px'
                                            : item.isInvalidReplenQty ===
                                              t(
                                                  'productValidationMessages.mustEnterValidQty'
                                              )
                                            ? '130px'
                                            : item.isInvalidReplenQty ===
                                              t(
                                                  'consignmentBilling.replen.replenListView.replenListViewMobile.replenishmentCannotEnterValidQty'
                                              )
                                            ? '250px'
                                            : '130px'
                                    }
                                    errorMessageMaxWidth={'100%'}
                                    styleObj={{
                                        textWithInputstyles: {
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                        },
                                        ...(!isMobileView && {
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                        }),
                                    }}
                                    float={isMobileView && 'right'}
                                />
                            )}
                        </Grid>
                    </Grid>
                    {item.isInvalidReplenQty && (
                        <Grid md={12} xs={12} sm={12} style={styles.errorStyle}>
                            <AlertMsg message={item.isInvalidReplenQty} />
                        </Grid>
                    )}
                    {item.isExcludedItem ? (
                        <Grid
                            item
                            md={6}
                            style={{ display: 'flex', maxWidth: '100%' }}
                        >
                            <AlertMsg
                                message={t(
                                    'consignmentBilling.replen.replenListView.replenListViewMobile.itemCannotBeReplenished'
                                )}
                            />
                        </Grid>
                    ) : (
                        <>
                            {item.shippingDetails ? (
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        width: '100%',
                                        marginTop: '20px',
                                        marginBottom: '5px',
                                    }}
                                >
                                    <Divider orientation="horizontal" />
                                </Grid>
                            ) : null}
                            <Grid
                                item
                                md={isMobileView ? 3 : 0}
                                xs={
                                    isTransferRecipient() && !isMobileView
                                        ? 4
                                        : !isMobileView
                                        ? 6
                                        : 0
                                }
                                style={{
                                    marginLeft: !isMobileView
                                        ? '21px'
                                        : 'unset',
                                }}
                            >
                                {item.shippingDetails ? (
                                    <StyledTextDiv
                                        width={'100%'}
                                        color={'#202124'}
                                        fontSize={'14px'}
                                        fontWeight={'bold'}
                                        marginLeft={
                                            isMobileView ? '28px' : 'unset'
                                        }
                                        marginRight={
                                            isMobileView ? '50px' : 'unset'
                                        }
                                        padding={
                                            isMobileView
                                                ? '13px 0 5px 0'
                                                : 'unset'
                                        }
                                    >
                                        {t(
                                            'consignmentBilling.replen.replenListView.replenListViewMobile.shippingAdress'
                                        )}
                                    </StyledTextDiv>
                                ) : null}
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={isMobileView ? '100%' : '75%'}
                                    marginLeft={isMobileView ? '28px' : 'unset'}
                                    marginRight={isMobileView ? '0px' : 'unset'}
                                    label={
                                        item.shippingDetails && (
                                            <>
                                                {item.shippingDetails
                                                    .attnLine && (
                                                    <StyledShippingDetails>
                                                        {t(
                                                            'consignmentBilling.replen.replenListView.replenListViewMobile.attn'
                                                        )}{' '}
                                                        <span className="report-usage-account-address-dt-mask">{item.shippingDetails
                                                                .attnLine}</span>
                                                    </StyledShippingDetails>
                                                )}
                                                {item?.shippingDetails
                                                    ?.transferRecipient && (
                                                    <StyledShippingDetails className="report-usage-shipping-address-dt-mask">
                                                        {
                                                            item
                                                                ?.shippingDetails
                                                                ?.transferRecipient
                                                                ?.city
                                                        }
                                                    </StyledShippingDetails>
                                                )}
                                                {item.shippingDetails
                                                    .shippingAddress && (
                                                    <StyledShippingDetails>
                                                        <SelectedShipToAddressLabel
                                                            address={
                                                                item
                                                                    .shippingDetails
                                                                    .shippingAddress
                                                            }
                                                        />
                                                    </StyledShippingDetails>
                                                )}
                                                {item?.shippingDetails
                                                    ?.careOf && (
                                                    <StyledShippingDetails>
                                                        {t(
                                                            'consignmentBilling.replen.replenListView.replenListViewDesktop.Careof'
                                                        )}{' '}
                                                        <span className="report-usage-shipping-address-dt-mask">{
                                                            item
                                                                ?.shippingDetails
                                                                ?.careOf
                                                        }</span>
                                                    </StyledShippingDetails>
                                                )}
                                            </>
                                        )
                                    }
                                />
                            </Grid>
                            {isTransferRecipient() && (
                                <Grid
                                    item
                                    md={isMobileView ? 3 : 0}
                                    xs={
                                        isTransferRecipient() && !isMobileView
                                            ? 4
                                            : !isMobileView
                                            ? 6
                                            : 0
                                    }
                                    style={{
                                        marginLeft: !isMobileView
                                            ? '21px'
                                            : 'unset',
                                    }}
                                >
                                    {item.shippingDetails ? (
                                        <StyledTextDiv
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            fontWeight={'bold'}
                                            marginLeft={
                                                isMobileView ? '28px' : 'unset'
                                            }
                                            marginRight={
                                                isMobileView ? '50px' : 'unset'
                                            }
                                            padding={
                                                isMobileView
                                                    ? '13px 0 5px 0'
                                                    : 'unset'
                                            }
                                        >
                                            {t(
                                                'reportUsage.replen.selectShipToAddress.transferRecipient'
                                            )}
                                        </StyledTextDiv>
                                    ) : null}
                                    <CustomLabel
                                        fSize={'15px !important'}
                                        color={'#202124'}
                                        letterSpacing={'0px !important'}
                                        fWeight={'normal !important'}
                                        maxWidth={isMobileView ? '100%' : '75%'}
                                        marginLeft={
                                            isMobileView ? '28px' : 'unset'
                                        }
                                        marginRight={
                                            isMobileView ? '0px' : 'unset'
                                        }
                                        label={
                                            item.shippingDetails && (
                                                <>
                                                    {item?.shippingDetails
                                                        ?.transferRecipient && (
                                                        <StyledShippingDetails className="report-usage-shipping-address-dt-mask">
                                                            {getSelectedShipToAddress(
                                                                item
                                                                    .shippingDetails
                                                                    ?.transferRecipient
                                                                    ? item
                                                                          .shippingDetails
                                                                          ?.transferRecipient
                                                                    : ''
                                                            )}
                                                        </StyledShippingDetails>
                                                    )}
                                                </>
                                            )
                                        }
                                    />
                                </Grid>
                            )}
                            <Grid
                                item
                                md={3}
                                xs={
                                    isTransferRecipient() && !isMobileView
                                        ? 3
                                        : !isMobileView
                                        ? 4
                                        : 0
                                }
                                style={{
                                    width:
                                        window.innerWidth === sizes.smalDevice
                                            ? '30%'
                                            : '',
                                }}
                            >
                                {item.shippingDetails ? (
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'14px'}
                                        fontWeight={'bold'}
                                        marginLeft={
                                            isMobileView ? '28px' : 'unset'
                                        }
                                        marginRight={
                                            isMobileView ? '30px' : 'unset'
                                        }
                                        padding={
                                            isMobileView
                                                ? '20px 0 5px 0'
                                                : 'unset'
                                        }
                                    >
                                        {t(
                                            'reportUsage.replen.replenListView.shippingMethod'
                                        )}
                                    </StyledTextDiv>
                                ) : null}
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'75%'}
                                    marginLeft={isMobileView ? '28px' : 'unset'}
                                    marginRight={
                                        isMobileView ? '30px' : 'unset'
                                    }
                                    label={
                                        item.shippingDetails && (
                                            <StyledShippingDetails className="report-usage-shipping-method-dt-mask">
                                                {item.shippingDetails
                                                    .shippingMethod
                                                    ? item.shippingDetails
                                                          .shippingMethod
                                                          .shippingMethodName
                                                    : ''}
                                            </StyledShippingDetails>
                                        )
                                    }
                                />
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'75%'}
                                    marginLeft={isMobileView ? '28px' : 'unset'}
                                    marginRight={
                                        isMobileView ? '30px' : 'unset'
                                    }
                                    label={
                                        item?.shippingDetails?.surgeryDate && (
                                            <>
                                                {/* <StyledShippingDetails>
                                                    (
                                                    {t(
                                                        'consignmentBilling.replen.replenListView.replenListViewMobile.requestedDelivery'
                                                    )}
                                                </StyledShippingDetails> */}
                                                <StyledTextDiv
                                                    color={'#202124'}
                                                    fontSize={'14px'}
                                                    fontWeight={'bold'}
                                                    // marginLeft={
                                                    //     isMobileView
                                                    //         ? '28px'
                                                    //         : 'unset'
                                                    // }
                                                    marginRight={
                                                        isMobileView
                                                            ? '50px'
                                                            : 'unset'
                                                    }
                                                    padding={
                                                        isMobileView
                                                            ? '13px 0 5px 0'
                                                            : 'unset'
                                                    }
                                                >
                                                    {t(
                                                        'common.surgeryDateLabel'
                                                    )}{' '}
                                                </StyledTextDiv>
                                                <StyledShippingDetails>
                                                    {item?.shippingDetails
                                                        ?.surgeryDate
                                                        ? getDisplayDate(
                                                              item
                                                                  .shippingDetails
                                                                  ?.surgeryDate
                                                          )
                                                        : ''}
                                                    {/* ) */}
                                                </StyledShippingDetails>
                                            </>
                                        )
                                    }
                                />
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'75%'}
                                    marginLeft={isMobileView ? '28px' : 'unset'}
                                    marginRight={
                                        isMobileView ? '30px' : 'unset'
                                    }
                                    label={
                                        item?.shippingDetails
                                            ?.requestDeliveryDate && (
                                            <>
                                                <StyledTextDiv
                                                    width={'100%'}
                                                    color={'#202124'}
                                                    fontSize={'14px'}
                                                    fontWeight={'bold'}
                                                    marginRight={
                                                        isMobileView
                                                            ? '50px'
                                                            : 'unset'
                                                    }
                                                    padding={
                                                        isMobileView
                                                            ? '13px 0 5px 0'
                                                            : 'unset'
                                                    }
                                                >
                                                    {t(
                                                        'consignmentBilling.replen.replenListView.replenListViewMobile.requestedDelivery'
                                                    )}{' '}
                                                    {t('announcements.date')}{' '}
                                                </StyledTextDiv>

                                                <StyledShippingDetails>
                                                    {item?.shippingDetails
                                                        ?.requestDeliveryDate
                                                        ? getDisplayDate(
                                                              item
                                                                  .shippingDetails
                                                                  ?.requestDeliveryDate
                                                          )
                                                        : ''}
                                                </StyledShippingDetails>
                                            </>
                                        )
                                    }
                                />
                            </Grid>
                            {/* <Grid
                                item
                                md={isMobileView ? 3 : 0}
                                xs={!isMobileView ? 6 : 0}
                                style={{
                                    marginLeft: !isMobileView
                                        ? '21px'
                                        : 'unset',
                                }}
                            >
                                {item.shippingDetails?.requestDeliveryDate ? (
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'14px'}
                                        fontWeight={'bold'}
                                        marginLeft={
                                            isMobileView ? '28px' : 'unset'
                                        }
                                        marginRight={
                                            isMobileView ? '30px' : 'unset'
                                        }
                                        padding={
                                            isMobileView
                                                ? '20px 0 5px 0'
                                                : 'unset'
                                        }
                                    >
                                        Request Delivery Date
                                    </StyledTextDiv>
                                ) : null}
                                <CustomLabel
                                    fSize={'15px !important'}
                                    color={'#202124'}
                                    letterSpacing={'0px !important'}
                                    fWeight={'normal !important'}
                                    maxWidth={'75%'}
                                    marginLeft={isMobileView ? '28px' : 'unset'}
                                    marginRight={
                                        isMobileView ? '30px' : 'unset'
                                    }
                                    label={
                                        item.shippingDetails
                                            ?.requestDeliveryDate && (
                                            <StyledShippingDetails>
                                                {item.shippingDetails
                                                    ?.requestDeliveryDate
                                                    ? getDisplayDate(
                                                          item.shippingDetails
                                                              ?.requestDeliveryDate
                                                      )
                                                    : ''}
                                            </StyledShippingDetails>
                                        )
                                    }
                                />
                            </Grid> */}
                        </>
                    )}
                </Grid>
            </Box>
        </>
    );
};

const styles = {
    errorStyle: {
        display: 'flex',
        paddingTop: '7px',
        maxWidth: '100%',
        marginLeft: '38px',
    },
};
export default RowTemplateMobile;
